export default "__VITE_ASSET__Cwn03Tha__"